export const DEFAULT_VALUE_STYLE = {
  Point: {
    icon: {
      icon_type: 'shape',
      shape_type: 'square',
      fill: '#000000',
      stroke: '#000000',
      'fill-opacity': 1,
      image: null,
    },
    opacity: 1,
  },
  Line: {
    stroke: '#000000',
    'stroke-opacity': 1,
    'stroke-width': 1,
    'stroke-dasharray': [],
  },
  Text: {
    fill: '#000000',
    'font-size': 10,
    label: 'name',
    'font-style': 'normal',
    'fill-opacity': 1,
  },
  Polygon: { fill: '#000000', 'fill-opacity': 1 },
}
